var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExternalLinkIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 2V3.33301H3.33301V12.667H12.667V8H14V12.667C13.9998 13.4001 13.4001 13.9998 12.667 14H3.33301C2.59327 13.9998 2.00018 13.4001 2 12.667V3.33301C2.00018 2.59993 2.59327 2.00018 3.33301 2H8ZM14 2V6.66699H12.667V4.27344L6.11328 10.8271L5.17285 9.88672L11.7266 3.33301H9.33301V2H14Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgExternalLinkIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/external-link-icon.67b0dfb74682ee71a0f101acc3415b8c.svg";